import { useState, useEffect, useLayoutEffect, useRef } from 'react';

const EDGE_GAP = 8;

export const FilterDropdown = ({ value, onChange, options, placeholder, disabled = false, currentLabel, className = '', triggerClassName = '' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const menuRef = useRef(null);
    const [shiftX, setShiftX] = useState(0);

    useLayoutEffect(() => {
        if (!isOpen) { setShiftX(0); return; }
        const menu = menuRef.current;
        if (!menu) return;
        const rect = menu.getBoundingClientRect();
        const bounds = (dropdownRef.current && dropdownRef.current.closest('.oc-lead-card__dialog'))?.getBoundingClientRect();
        const minLeft = Math.max(0, bounds ? bounds.left : 0) + EDGE_GAP;
        const maxRight = Math.min(window.innerWidth, bounds ? bounds.right : window.innerWidth) - EDGE_GAP;
        let dx = 0;
        if (rect.right > maxRight) dx = maxRight - rect.right;
        if (rect.left + dx < minLeft) dx = minLeft - rect.left;
        setShiftX(dx);
    }, [isOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);

    const selectedOption = options.find(o => o.value === value);
    const displayLabel = selectedOption?.label || currentLabel || placeholder;

    const handleSelect = (optionValue) => {
        onChange(optionValue);
        setIsOpen(false);
    };

    return (
        <div className={`filter-dropdown${className ? ` ${className}` : ''}`} ref={dropdownRef}>
            <div
                className={`filter-dropdown__trigger${isOpen ? ' filter-dropdown__trigger--open' : ''}${disabled ? ' filter-dropdown__trigger--disabled' : ''}${triggerClassName ? ` ${triggerClassName}` : ''}`}
                onClick={() => { if (!disabled) setIsOpen(!isOpen); }}
                aria-disabled={disabled || undefined}
            >
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {selectedOption?.dot && (
                        <span
                            className={`filter-dropdown__dot ${selectedOption.dotClass || ''}`}
                            style={selectedOption.dotStyle || {}}
                        />
                    )}
                    {displayLabel}
                </span>
            </div>
            {isOpen && !disabled && (
                <div className='filter-dropdown__menu' ref={menuRef} style={shiftX ? { transform: `translateX(${shiftX}px)` } : undefined}>
                    {options.map(option => (
                        <button
                            type='button'
                            key={option.value}
                            className={`filter-dropdown__item ${option.itemClass || ''}${option.value === value ? ' filter-dropdown__item--active' : ''}`}
                            onClick={() => handleSelect(option.value)}
                        >
                            {option.dot && (
                                <span
                                    className={`filter-dropdown__dot ${option.dotClass || ''}`}
                                    style={option.dotStyle || {}}
                                />
                            )}
                            {option.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};
